import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (measurementId && process.env.NODE_ENV === 'production') {
    ReactGA.initialize(measurementId);
  } else if (process.env.NODE_ENV === 'development') {
    console.log('Google Analytics: Development mode - tracking disabled');
  }
};

// Track page views
export const logPageView = (path) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID && process.env.NODE_ENV === 'production') {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

// Track custom events
export const logEvent = (category, action, label = null, value = null) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID && process.env.NODE_ENV === 'production') {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

// Track form submissions
export const logFormSubmission = (formName) => {
  logEvent('Form', 'Submit', formName);
};

// Track button clicks
export const logButtonClick = (buttonName) => {
  logEvent('Button', 'Click', buttonName);
};

// Track outbound links
export const logOutboundLink = (url) => {
  logEvent('Outbound Link', 'Click', url);
};
